/* eslint-disable @typescript-eslint/naming-convention */
import { FC, useState } from 'react'
import {
  ProductGallery,
  ProductQuantity,
  ProductDescription,
  ProductPrice,
  ProductDeliveryDays,
  ProductFreight,
} from 'modules/products/components'
import { SellerInline } from 'modules/sellers/components'
import { BrowserView, MobileOnlyView } from 'react-device-detect'
import type { ProductViewProps } from '.'
import s from './product-view.module.css'
import { ProductBuy } from '..'

const ProductView: FC<ProductViewProps> = ({ 
  product, 
  isAfiliado, 
  isFavorite, 
  loadingFavorite, 
  onToggleFavorite, 
  StarFilled, 
  StarOutline 
}) => {
  const [quantity, setQuantity] = useState<number>(1)
  const { image, images, name, description, price, seller, days, stock, national, categorias_slug, assinatura } = product

  function changeQuantity({ next }: { next: number }) {
    setQuantity(next)
  }

  const imagesSet = !image || image === '' ? images : [{ url: image }, ...images]

  return (
    <div className={s.root}>
      <div className={s.gallery}>
        <div style={{ position: 'relative' }}>
          {/* Estrela de favoritos para afiliado */}
          {isAfiliado && StarFilled && StarOutline && onToggleFavorite && (
            <div
              className={isFavorite ? s.favoriteStar : `${s.favoriteStar} ${s['favoriteStar--empty']}`}
              style={{ position: 'absolute', top: 8, right: 8, zIndex: 2, cursor: loadingFavorite ? 'not-allowed' : 'pointer' }}
              onClick={onToggleFavorite}
              title={isFavorite ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
            >
              {isFavorite ? <StarFilled /> : <StarOutline />}
            </div>
          )}
          <ProductGallery key="product-view-gallery" title={product.name} images={imagesSet} />
        </div>
        <div className={s.categories}>
          {categorias_slug.includes('Sem Lactose') && <img src="/assets/icons/sem-lactose.webp" alt="Sem lactose" />}
          {categorias_slug.includes('Sem Açúcar') && <img src="/assets/icons/sem-acucar.webp" alt="Sem açúcar" />}
          {categorias_slug.includes('Sem Glúten') && <img src="/assets/icons/sem-gluten.webp" alt="Sem glúten" />}
          {categorias_slug.includes('Vegano') && <img src="/assets/icons/vegano.webp" alt="Vegano" />}
          {categorias_slug.includes('Orgânico') && <img src="/assets/icons/organico.webp" alt="Orgânico" />}
        </div>
      </div>
      <div className={s.info}>
        <h1 className={s.title}>{name}</h1>
        <SellerInline {...seller} pre="Vendido e entregue por" className={s.seller} />
        <ProductDescription description={description} />
        <MobileOnlyView>
          <div className={s.free}>{price.sell >= 200 && 'Frete Grátis'}</div>
        </MobileOnlyView>
        {assinatura && <div>
          <p><br/>
            <b>Compras em formato de Assinatura</b><br/>
            Assine e receba na periodicidade desejada poupando seu tempo e sem riscos de esquecimento.<br/>
            • Frete Grátis<br/>
            • Sem taxa de adesão<br/>
            • Cancele quando quiser na área do cliente aqui pelo site<br/>
            • Altere a periodicidade de recebimento facilmente<br/>
            As assinaturas só são possíveis de serem pagas com cartão de crédito.<br/><br/>
          </p>
        </div>}
        <ProductPrice
          price={price}
          preco_promocional={product.preco_promocional}
          preco_promocional_ativo={product.preco_promocional_ativo}
        />
        <div className={s.cta}>
          {stock && stock > 0 && product.status !== 'INATIVO' ? (
            <>
              <ProductQuantity
                canChange
                onChange={changeQuantity}
                quantity={quantity}
                dropdown={false}
                maximum={stock}
              />
              <ProductBuy product={product} quantity={quantity} />
              <BrowserView>
                {product.preco_promocional && product.preco_promocional_ativo ? (
                  <div className={s.free}>{product.preco_promocional >= 200 && 'Frete Grátis'}</div>
                ) : (
                  <div className={s.free}>{price.sell >= 200 && 'Frete Grátis'}</div>
                )}
              </BrowserView>
            </>
          ) : (
            <span className={s.outOfStock}>Produto sem estoque</span>
          )}
        </div>
        {/* {stock && stock > 0 ? (
          <>
            {national ? <ProductFreight product={product} quantity={quantity} /> : <ProductDeliveryDays days={days} className={s.days} />}
          </>
        ) : null} */}
      </div>
    </div>
  )
}

export default ProductView
